import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { TagModule } from 'primeng/tag';

enum TextType {
  Human = 'human',
  AI = 'ai'
}

@Component({
  selector: 'app-history-chat-logs',
  standalone: true,
  imports: [
    NgIf,
    CalendarModule,
    FormsModule,
    DatePipe,
    TagModule
  ],
  templateUrl: './history-chat-logs.component.html',
  styleUrl: './history-chat-logs.component.scss'
})
export class HistoryChatLogsComponent {
  @Input() logs: any;
  @Input() contactInfo: any;
  @Input() hostName: any;
  @Input() propertyName: any;
  @Input() propertyNumber: any;
  @Input() senderNumber: any;
  @Input() source: any;
  @Input() propertyTimezone: string = '';
  @Output() close = new EventEmitter<any>();
  TextType = TextType;
  date: Date | undefined;

  formatMessageTime(time: any): string {
    if (!time) return '';
    const date = new Date(time);
    if (isNaN(date.getTime())) return '';
    const tz = this.propertyTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    return new Intl.DateTimeFormat('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: tz,
    }).format(date);
  }

  closeChat() {
    this.close.emit();
  }
}